module.exports = __webpack_public_path__ + "static/img/YORK老师_Ling.7c0728c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK老师_Ling.png
// module id = BP5R
// module chunks = 0